import { cn } from "@/lib/utils"
import { Link } from "react-router-dom";
import darkLogo from "../assets/status-bot-logo-dark.svg";
import lightLogo from "../assets/status-bot-logo-light.svg";
import { useTheme } from "@/components/theme-provider";

const Logo = ({ className = '', onClick, variant = 'auto', width = '200px' }) => {
  const { theme } = useTheme();
  
  // Get system theme preference
  const systemTheme = typeof window !== 'undefined' 
    ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
    : "light";
    
  // Use system theme if theme is set to system
  const effectiveTheme = theme === "system" ? systemTheme : theme;
  
  const logoSrc = variant === 'auto' 
    ? (effectiveTheme === "dark" ? darkLogo : lightLogo)
    : (variant === 'dark' ? darkLogo : lightLogo);

  return (
    <div 
      className={`cursor-pointer ${className}`}
      onClick={onClick}
    >
      <Link to="/today" className={cn("inline-block align-middle py-1")}>
        <img 
          src={logoSrc}
          alt="status.bot logo"
          className="h-auto"
          style={{ width }}
        />
      </Link>
    </div>
  );
};

export default Logo;